var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion", class: _vm.accordionClass },
    [
      _c(
        "a",
        {
          staticClass: "accordion__header",
          class: _vm.headerClass,
          attrs: { href: "#", "data-accordian": _vm.heading },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.activate($event)
            }
          }
        },
        [
          _c(
            "span",
            { staticClass: "accordion__menu-title" },
            [_vm._t("heading", [_vm._v(_vm._s(_vm.heading))])],
            2
          ),
          _c("icon", {
            staticClass: "accordion-icon",
            attrs: { name: _vm.currentIcon, size: "10px" }
          })
        ],
        1
      ),
      _c("transition", { attrs: { name: _vm.transition } }, [
        _c(
          "div",
          {
            ref: "content",
            staticClass: "accordion__content",
            class: _vm.active ? "show" : "hide",
            style: _vm.contentStyle
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }